import { AlertSource } from "./alerts";

// Mirrors apps/api/types/alertLabels.ts.
// Display order for the alert-label settings rows.
export const ALERT_LABEL_SOURCES: ReadonlyArray<AlertSource> = [
  AlertSource.ETHOCA,
  AlertSource.VERIFI_CDRN,
  AlertSource.VERIFI_RDR,
];

export const AlertSourceLabel: Record<AlertSource, string> = {
  [AlertSource.ETHOCA]: "Ethoca",
  [AlertSource.VERIFI_CDRN]: "CDRN",
  [AlertSource.VERIFI_RDR]: "RDR",
};

// Ethoca alerts carry no dispute reason, so its labels may not reference one; they do carry a
// Fraud / Dispute type, which the other sources' labels have no use for.
export const PLACEHOLDERS_BY_SOURCE: Record<AlertSource, ReadonlyArray<string>> = {
  [AlertSource.ETHOCA]: ["${alertType}"],
  [AlertSource.VERIFI_CDRN]: ["${reasonCode}", "${reasonDescription}"],
  [AlertSource.VERIFI_RDR]: ["${reasonCode}", "${reasonDescription}"],
};

export type AlertLabels = Partial<Record<AlertSource, string>>;

export const ALERT_LABEL_COLUMNS = ["alert_order_tags", "alert_refund_reasons"] as const;

export type AlertLabelColumn = typeof ALERT_LABEL_COLUMNS[number];

export const AlertLabelColumnLabel: Record<AlertLabelColumn, string> = {
  alert_order_tags: "Shopify order tags",
  alert_refund_reasons: "Refund reason",
};

export const ALERT_LABEL_MAX_LENGTH = 255;

// Mirrors apps/api/constants/shopifyTags.ts: Shopify truncates order tags past this.
export const SHOPIFY_MAX_ORDER_TAG_LENGTH = 40;
